module.exports = __webpack_public_path__ + "static/media/p3.094f620e.png";